// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1',
  TIMEOUT: 30000, // 30 seconds
};

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    SIGNUP: '/auth/signup/',
    LOGIN: '/auth/login/',
    LOGOUT: '/auth/logout/',
    PROFILE: '/auth/profile/',
    CHANGE_PASSWORD: '/auth/change-password/',
    FORGOT_PASSWORD: '/auth/forgot-password/',
    RESET_PASSWORD: '/auth/reset-password/',
    VERIFY_EMAIL: '/auth/verify-email/',
    RESEND_VERIFICATION: '/auth/resend-verification/',
    REFRESH_TOKEN: '/auth/token/refresh/',
    VALIDATE_TOKEN: '/auth/token/validate/',
  },
  
  // Research/Search
  RESEARCH: {
    GLOBAL_SEARCH: '/research/search/',
    CLINICAL_TRIALS: '/research/search/clinical-trials/',
    FDA_SEARCH: '/research/search/fda/',
    PATENTS: '/research/search/patents/',
    PUBMED: '/research/search/pubmed/',
    REGULATIONS: '/research/search/regulations/',
    DATA_VIEW_API: '/research/data-view/api/',
    DATA_VIEW_DETAIL: '/research/data-view/detail/',
    DATA_VIEW_SEARCH: '/research/data-view/search/',
    DATA_VIEW_COMPANY_LIST: '/research/data-view/company/list/',
    DATA_VIEW_COMPANY_DETAIL: '/research/data-view/company/detail/',
    DATA_VIEW_COMPANY_SEARCH: '/research/data-view/company/search/',
    DATA_VIEW_DOWNLOAD: '/research/data-view/download/',
    
    // Saved Searches
    SAVED_SEARCHES: '/research/saved-searches/',
    SAVED_SEARCH_DETAIL: (id) => `/research/saved-searches/${id}/`,
    EXECUTE_SAVED_SEARCH: (id) => `/research/saved-searches/${id}/execute/`,
    
    
    // Filters & Facets
    AVAILABLE_FILTERS: '/research/filters/',
    SEARCH_FACETS: '/research/facets/',
    
    // Bookmarks & History
    BOOKMARKS: '/research/bookmarks/',
    BOOKMARK_DETAIL: (id) => `/research/bookmarks/${id}/`,
    SEARCH_HISTORY: '/research/history/',
  },
  
  // Admin
  ADMIN: {
    USERS: '/admin/users/',
    USER_DETAIL: (id) => `/admin/users/${id}/`,
    USER_ACTIVITY: (id) => `/admin/users/${id}/activity/`,
    DATA_VIEW_API: '/admin/data-view/list/',
    DATA_VIEW_DETAIL: '/admin/data-view/detail/',
    DATA_VIEW_UPDATE: '/admin/data-view/detail/',
    DATA_VIEW_REVERT: '/admin/data-view/detail/revert/',
    DATA_VIEW_SEARCH: '/admin/data-view/search/',
    DATA_VIEW_COMPANY_LIST: '/admin/data-view/company/list/',
    DATA_VIEW_COMPANY_DETAIL: '/admin/data-view/company/detail/',
    DATA_VIEW_COMPANY_SEARCH: '/admin/data-view/company/search/',
    DATA_VIEW_DOWNLOAD: '/admin/data-view/download/',
    DATA_VIEW_COMPANY_MERGE: '/admin/data-view/company/merge/',
    DATA_VIEW_COMPANY_ADD_SOURCES: '/admin/data-view/company/add-sources/',
    DATA_VIEW_COMPANY_REMOVE_SOURCES: '/admin/data-view/company/remove-sources/',
    DATA_VIEW_COMPANY_DELETE: '/admin/data-view/company/delete/',
    PUBMED_PREVIEW: '/admin/pubmed/preview/',
    PUBMED_INGEST: '/admin/pubmed/ingest/',
    PUBMED_DELETE: (pmid) => `/admin/pubmed/${pmid}/`,
    FIELD_ACCESS_DATASETS: '/admin/field-access/',
    FIELD_ACCESS_DETAIL: (datasetKey) => `/admin/field-access/${datasetKey}/`,
    
    SYSTEM_HEALTH: '/admin/system/health/',
    SYSTEM_STATS: '/admin/system/stats/',
    SYSTEM_LOGS: '/admin/system/logs/',
    SYSTEM_LOG_DETAIL: (group, collection) => `/admin/system/logs/${group}/${collection}/`,

    ACTIVITY_LOGS: '/admin/activity-logs/',
  },
  
  // Support
  SUPPORT: {
    TICKETS: '/support/tickets/',
    TICKET_DETAIL: (id) => `/support/tickets/${id}/`,
    FAQ: '/support/faq/',
    CONTACT: '/support/contact/',
  },
  
  // Notifications
  NOTIFICATIONS: {
    LIST: '/notifications/',
    MARK_READ: (id) => `/notifications/${id}/read/`,
    MARK_ALL_READ: '/notifications/mark-all-read/',
    PREFERENCES: '/notifications/preferences/',
  },
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
};
